export const DISPLAY_TYPE_ID_MAP = {
  MULTIPLE_CHOICE: '1'
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/display-type/display-type-id-map.ts